/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = require('react/lib/ReactComponentWithPureRenderMixin');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-pure-render-mixin/index.js
 ** module id = 132
 ** module chunks = 0
 **/